import { render, staticRenderFns } from "./incidents-severities-grid.vue?vue&type=template&id=33cefd7a&scoped=true&"
import script from "./incidents-severities-grid.ts?vue&type=script&lang=ts&"
export * from "./incidents-severities-grid.ts?vue&type=script&lang=ts&"
import style0 from "./incidents-severities-grid.scss?vue&type=style&index=0&id=33cefd7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cefd7a",
  null
  
)

export default component.exports